// extracted by mini-css-extract-plugin
export default {"ActionList_LinkItem":"LinkedBranches-module__ActionList_LinkItem__vghJb1v","ActionList_LeadingVisual":"LinkedBranches-module__ActionList_LeadingVisual__J2PmNKA"};